import * as React from 'react';
import { TranslationsProvider } from '../../i18next';
import { sendSolutionImpressionBi } from '../../bi/events';
import { composer } from '../../component-decorators/composer';
import { useCallback, useState, useEffect } from 'react';
import { Cell, Layout, Carousel, Box } from '@wix/design-system';
import { PromoBoxCompact } from './promo-box-compact';
import { getAppBadgeTheme, getAppBadgeTitle, getAppBadgeTooltipContent, } from '../common';
import { useMediaQuery } from 'react-responsive';
import { VisibilityDetector } from '../../utils/visibility-detector';
const PromoWidgetBase = composer()
    .withExperiments()
    .compose(({ solution, solutionsBiData, locale, onPromoClickHandler, onBoxClick, as, i18n, hideCTA, isMobile, index, experiments, hideTagsBadge, }) => {
    const badgeTitle = getAppBadgeTitle(solution.isBundleAppInstalled, solution.isBundleAppNotInstalled, solution.Tags, experiments, hideTagsBadge, solution?.id);
    return (React.createElement(PromoBoxCompact, { key: index, solution: solution, solutionBiData: solutionsBiData && solutionsBiData[index], onPromoClickHandler: onPromoClickHandler, onBoxClick: onBoxClick, as: as, hideCTA: hideCTA, badgeTitle: badgeTitle, badgeTheme: getAppBadgeTheme(badgeTitle), showTooltip: solution.isBundleAppInstalled ||
            solution.isBundleAppNotInstalled ||
            true, tooltipContent: getAppBadgeTooltipContent(solution.isBundleAppInstalled, solution.isBundleAppNotInstalled, solution.isVoucherApp), isMobile: isMobile }));
});
export const PromoWidget = composer()
    .withExperiments()
    .compose((props) => {
    const isInMobile = useMediaQuery({ query: '(max-width: 600px)' });
    const bigScreen = useMediaQuery({ query: '(min-width: 1484px)' });
    const [isImpression, setIsImpression] = useState(false);
    const [isBigScreen, setIsBigScreen] = useState(true);
    const onImpression = useCallback(() => {
        !isImpression &&
            props.solutionsBiData.map((solutionBiData) => {
                sendSolutionImpressionBi(solutionBiData);
                setIsImpression(true);
            });
    }, [setIsImpression, isImpression]);
    useEffect(() => {
        setIsBigScreen(bigScreen);
    }, [bigScreen]);
    return isInMobile ? (React.createElement("div", { "data-testid": "promo-widget" },
        React.createElement(TranslationsProvider, { i18n: props.i18n, locale: props.locale },
            React.createElement(VisibilityDetector, { onVisible: onImpression },
                React.createElement(Carousel, { variableWidth: true, dots: false, controlsPosition: "none", infinite: true }, props.solutions
                    .slice(0, 4)
                    .map((solution, index) => {
                    return (React.createElement(Box, { width: "222px", marginRight: "12px", key: index },
                        React.createElement(PromoWidgetBase, { ...props, isMobile: true, index, solution })));
                })))))) : (React.createElement("div", { "data-testid": "promo-widget" },
        React.createElement(TranslationsProvider, { i18n: props.i18n, locale: props.locale },
            React.createElement(VisibilityDetector, { onVisible: onImpression },
                React.createElement(Layout, { gap: "24px", cols: 12 }, props.solutions
                    .slice(0, isBigScreen ? 4 : 3)
                    .map((solution, index) => {
                    return (React.createElement(Cell, { span: isBigScreen ? 3 : 4, rows: 1, key: solution.id },
                        React.createElement(PromoWidgetBase, { ...props,
                            isMobile: false,
                            index,
                            solution })));
                }))))));
});
//# sourceMappingURL=promo-widget.js.map